
import get from 'lodash/get';
import VLazyImage from 'v-lazy-image';
import { DEAL_PLACEHOLDER_IMG } from '@/constants/global';

export default {
  components: {
    VLazyImage,
  },
  props: {
    deals: {
      type: Array,
      required: true,
    },
    more: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      lazyPlaceholderImage: DEAL_PLACEHOLDER_IMG,
    };
  },
  methods: {
    generateCardDescription(deal) {
      return get(deal, 'card_description');
    },
  },
};
